import React from 'react'
import { Helmet } from 'react-helmet'

import DeliverectLogo from '../../../public/images/Deliverect_Logo_Primary.png'
import { useRouter } from 'next/router'

export const SiteDataContext = React.createContext({})
export const LocationContext = React.createContext({})
export const MicroCopyContext = React.createContext({})
export const LocationContextProvider = LocationContext.Provider

const PageWrapper = ({ children, _data, pageContext, country = null, currentMarket }) => {
  const location = useRouter()

  if (location.pathname === '/offline-plugin-app-shell-fallback/') {
    return null
  }

  const match = location.pathname.match(/^\/([\w]{2})-?([\w]{2})?\//)

  let {
    settings,
    locale: lang,
    siteMetadata,
    market,
    allPublishedIntegrations,
    allMarketsByTitle,
    allMarkets,
    allMarketsSlugs,
    integrations,
    articleCategories,
    articles,
    pageId
  } = pageContext

  const isTextRtl = market?.slugPrefix?.split('-')[0] === 'ar' // text right to left (Arabic)

  location.slugPrefix =
    (market?.slugPrefix && `/${market?.slugPrefix}/`) || (match && match[0]) || '/'
  location.country = country || (match && match[2]) || ''

  const siteData = {
    settings: {
      pages: {
        homepage: { ...settings?.homepage },
        integrationsOverview: { ...settings?.integrationsOverviewPage },
        requestDemo: { ...settings?.requestYourIntegrationPage },
        requestIntegration: { ...settings?.requestYourIntegrationPage }
      },
      siteTitle: settings?.siteTitle,
      siteDescription: settings?.siteDescription?.siteDescription,
      siteImage: market?.image?.fixed?.src
    },
    site: { ...siteMetadata },
    lang,
    pageId,
    locale: market?.locale,
    allPublishedIntegrations,
    allMarketsByTitle,
    allMarkets,
    allMarketsSlugs,
    isTextRtl,
    integrations: integrations || [],
    articleCategories: articleCategories || [],
    articles: articles || [],
    market: {
      // Current Market
      id: currentMarket?.id,
      slug: currentMarket?.slugPrefix,
      title: currentMarket?.title,
      localName: currentMarket?.localName,
      isoCode: currentMarket?.countryIsoCode,
      languages: currentMarket?.languages,
      currencySymbol: currentMarket?.currencySymbol,
      pricing: currentMarket?.pricing,
      flagUrl: currentMarket?.svgFlag?.url,
      flagRoundUrl: currentMarket?.svgFlagRound?.url,
      pageTitlePrefix: currentMarket?.pageTitlePrefix,
      footer: currentMarket?.footer
    }
  }

  const links = []

  if (location.pathname.includes('/blog')) {
    links.push(
      <link
        key={`link-${links.length}`}
        rel="alternate"
        type="application/rss+xml"
        href={`https://www.deliverect.com${location.slugPrefix}blog/rss.xml`}
      />
    )
  }

  const structuredDataMarkup = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: siteData.market.pageTitlePrefix,
    description: pageContext?.metaTags?.description || '',
    url: location.href || '',
    image: `${process.env.NEXT_PUBLIC_SITE_URL}${DeliverectLogo.src}`
  }

  return (
    <LocationContextProvider value={location}>
      <SiteDataContext.Provider value={siteData}>
        <>
          <Helmet htmlAttributes={{ lang }}>
            {links}
            <script type="application/ld+json">
              {JSON.stringify(structuredDataMarkup, null, 2)}
            </script>
          </Helmet>
          {children}
        </>
      </SiteDataContext.Provider>
    </LocationContextProvider>
  )
}

export default PageWrapper
